<div>
	<div role="group" class="w-100 btn-group btn-group-toggle">
		<ng-container *ngIf="showSelectAll">
			<ng-container
				*ngTemplateOutlet="optionTemplate; context: { option: selectAllOption }"
			></ng-container>
		</ng-container>
		<ng-container *ngFor="let option of optionsForDisplay">
			<ng-container *ngTemplateOutlet="optionTemplate; context: { option: option }"></ng-container>
		</ng-container>
		<ng-template #optionTemplate let-option="option">
			<label
				class="btn"
				[ngClass]="{
					'btn-secondary': optionIsChecked(option),
					'btn-outline-dark': !optionIsChecked(option),
					'border-danger': fieldControl.invalid
				}"
			>
				<input
					type="checkbox"
					class="input_check_btn"
					[value]="option.value"
					(keyup.enter)="selectOption(option)"
					[checked]="optionIsChecked(option)"
					(change)="onCheckboxChange(option)"
				/>
				{{ option.name || option.value }}
			</label>
		</ng-template>
	</div>
</div>
